// extracted by mini-css-extract-plugin
export default {"sortOrderButton":"CollapseIcon_sortOrderButton__+uIOb","rotated":"CollapseIcon_rotated__D6Vv-"};